import { GetOfflineFileCheckQueryParamsType } from '@/modules/OfflineFiles/queries/getOfflineFileCheck/getOfflineFileCheckQuery.type';
import { getOfflineFileCheckFunction } from '@/modules/OfflineFiles/queries/getOfflineFileCheck/getOfflineFileCheckQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getOfflineFileCheckQueryOptions = (
  params: GetOfflineFileCheckQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GetOfflineFileCheck', params],
    queryFn: () => getOfflineFileCheckFunction(params),
    enabled: true,
    select: (res) => {
      const culprit = res.offline_list?.find(
        (item) => item.user_type === 'culprit',
      );
      const damaged = res.offline_list?.flatMap((item) =>
        item.user_type === 'damaged' ? item : [],
      );
      return {
        has_offline: res.has_offline,
        offline_list: {
          damaged,
          culprit,
        },
      };
    },
  });
};
